var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrazo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 496,
    viewBox: "0 0 1439 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1211.21 94.9189L1216.02 88.7168L1221.1 82.7389C1222.77 80.7158 1224.56 78.8177 1226.34 76.9077L1229.01 74.0416C1229.89 73.0777 1230.79 72.1296 1231.74 71.2292L1237.33 65.7371C1239.2 63.9164 1241.18 62.2245 1243.11 60.4613L1246.02 57.8452L1249.04 55.3501C1251.06 53.7058 1253.05 52.01 1255.11 50.4094C1263.36 44.007 1272.04 38.1797 1281.02 32.8424C1290.09 27.6399 1299.51 23.0365 1309.22 19.0875C1319 15.2655 1329.08 12.1912 1339.39 9.94799C1349.71 7.74046 1360.3 6.62976 1370.93 6.4691C1381.56 6.25291 1392.26 7.4608 1402.71 9.7556C1407.97 10.781 1413.08 12.4848 1418.19 14.0992L1425.69 17.0287C1426.95 17.4849 1428.16 18.072 1429.36 18.6631L1432.99 20.4124",
    stroke: "#9063CD",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.13 283.433L1208.71 144.391L1234.59 109.709C1242.89 98.7646 1252.42 88.679 1262.85 79.5812C1283.72 61.3973 1308.15 47.0752 1334.23 37.7354",
    stroke: "#FDDA24",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.456055 333.964C60.8006 244.272 194.159 199.757 295.932 236.698C340.866 253.007 380.189 281.598 416.599 311.998",
    stroke: "#FF7F41",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.849 206.134C225.197 203.898 244.772 204.206 263.934 207.151L267.529 207.677C268.728 207.853 269.911 208.119 271.103 208.337L278.24 209.716L285.306 211.406L288.836 212.268L292.328 213.278C301.685 215.807 310.783 219.222 319.743 222.915C324.171 224.895 328.633 226.803 332.93 229.072C337.308 231.174 341.504 233.632 345.734 236.022C347.854 237.204 349.866 238.582 351.937 239.856C353.989 241.161 356.072 242.416 358.038 243.856L364.012 248.053C365.964 249.449 367.772 250.824 369.659 252.208L414.492 285.402L504.157 351.789L548.99 384.983L560.198 393.28C563.928 396.013 567.688 398.909 571.377 401.426L582.482 409.224L593.96 416.446",
    stroke: "#FDDA24",
    strokeWidth: 14.981,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M897.194 442.461C904.548 439.827 911.6 436.461 918.767 433.377C922.289 431.703 925.757 429.912 929.257 428.188L934.496 425.576L939.6 422.714C942.993 420.79 946.43 418.938 949.789 416.958L959.709 410.748C963.063 408.747 966.222 406.456 969.427 404.233L974.228 400.891C975.831 399.778 977.446 398.683 978.965 397.458L988.225 390.305L990.542 388.52L992.767 386.624L997.213 382.822L1001.66 379.024C1002.4 378.385 1003.16 377.77 1003.88 377.114L1006 375.105L1014.5 367.072C1025.51 356.038 1036.14 344.576 1045.57 332.144C1050.38 326.128 1055.14 319.561 1059.92 313.145L1074.23 293.839L1102.86 255.226L1160.13 177.998",
    stroke: "#FF7F41",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M493.775 370.506L544.935 408.684L551.331 413.456L557.997 418.193C562.474 421.318 566.845 424.605 571.522 427.429L578.437 431.815L581.898 434.004C583.042 434.748 584.261 435.369 585.438 436.055C590.203 438.717 594.91 441.484 599.722 444.05C638.332 464.434 680.646 477.512 723.84 482.691",
    stroke: "#9063CD",
    strokeWidth: 25,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrazo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trazo.fbc90fc98dee889c32f2072f3db7857f.svg";